import React from "react";
import styles from "./loading.module.css";

function Loading() {
  return (
    <div className={styles.body}>
      <div className={styles.center}>
        <div className={styles.column}>
          <img alt="logo" src="/logo_loading.svg" />
          {/* <p>A carregar...</p> */}
          <div className={styles.loader}/>
        </div>
      </div>
    </div>
  );
}

export default Loading;